import { useMemo } from 'react'

import { useDataBounds } from '@/hooks/useDataBounds'
import { useNavigation } from '@/hooks/useNavigation'
import { useDispatch } from 'react-redux'

import { AnimatePresence } from 'framer-motion'

import { IncidentsByMarketFacilityQuery } from '@/graphql/generated/operations'
import { openIncidentDrawer, setIncident } from '@/redux/ui/uiSlice'
import { GlobalMapProperties } from '@/utils/helpers'

import { dataToGeoJSONPoint, getFacilitiesPoints } from '../mapbox'
import { MapBox } from '../mapbox/components/MapBox'

interface GlobalMapIProps {
  facilitiesData: GlobalMapProperties[]
  height: number
  marketFacilityIncidentsData: IncidentsByMarketFacilityQuery
  width: number
}

export const GlobalMap = ({
  facilitiesData,
  height,
  marketFacilityIncidentsData,
  width,
}: GlobalMapIProps) => {
  const dispatch = useDispatch()
  const { goToFloorPlan } = useNavigation()
  const { setDataBounds } = useDataBounds()

  const facilitiesPoints = useMemo(
    () => getFacilitiesPoints(facilitiesData),
    [facilitiesData]
  )

  const openFloorPlan = (floorId: string) => {
    if (floorId) {
      goToFloorPlan(floorId)
    }
  }

  const dataPoints = useMemo(
    () => dataToGeoJSONPoint(facilitiesData, marketFacilityIncidentsData),
    [facilitiesData, marketFacilityIncidentsData]
  )

  const incidentMarkerClick = (id: string) => {
    dispatch(setIncident({ id }))
    dispatch(openIncidentDrawer())
  }
  return (
    <AnimatePresence>
      {!!width && !!height && (
        <MapBox
          facilitiesPoints={facilitiesPoints}
          features={dataPoints}
          height={height}
          onFacilityClick={openFloorPlan}
          onIncidentMarkerClick={incidentMarkerClick}
          setDataBounds={setDataBounds}
          width={width}
        />
      )}
    </AnimatePresence>
  )
}
